import { Box, Divider, IconButton, Toolbar, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { RequestError, useApi } from "../../services";
import { ErrorModal, googleSateliteHybrid, HidroLayer, HidroLayerComponent, HidroLayerGroup, HidroLayersComponent, HidroMap, LoadingModal, PolyMancha } from "../../components";
import { Home } from "@mui/icons-material";

export const BarragemManchas: React.FC = () => {
  const api = useApi();
  const { barragem } = useParams<{ barragem: string; }>();

  const navigate = useNavigate();

  const layers = useRef(new HidroLayerGroup({
    name: "Manchas",
    showing: true,
    layers: [],
  }));

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<RequestError>();
  const [idsManchas, setIdsManchas] = useState<number[]>([]);

  useEffect(() => {
    if (!barragem) return;

    api.barragem.getBarragemManchas(parseInt(barragem)).then((data) => {
      if ("error" in data) {
        setError(data);
        return;
      }
      setIdsManchas(data.manchas);
    });
  }, [barragem]);

  useEffect(() => {
    if (idsManchas.length === 0) return;
    setLoading(true);

    const getManchas = async () => {
      const reqManchas = [];
      for (const id of idsManchas) {
        const mancha = api.manchas.get(id);
        reqManchas.push(mancha);
      }

      const manchas = await Promise.all(reqManchas);

      console.log(manchas.length);

      const error = manchas.find(obj => "error" in obj);
      if (error) {
        setError(error as RequestError);
        setLoading(false);
        return;
      }

      layers.current.clearLayers();

      if (manchas.length > 0) {

        const group = new HidroLayerGroup({
          name: "Manchas",
          showing: true,
          layers: [],
        });

        layers.current.push(group);

        (manchas as PolyMancha[]).forEach((mancha) => {
          if ("error" in mancha) return;

          group.push(new HidroLayer({
            layer: mancha,
            showing: true,
            name: mancha.properties?.nome ?? "Mancha",
          }));
        });
      }

      layers.current.push(new HidroLayer({
        name: "Mapa",
        showing: true,
        layer: googleSateliteHybrid(),
      }));

      setLoading(false);
    };

    getManchas();
  }, [idsManchas]);

  return <>
    {loading && <LoadingModal open={loading} />}
    {error && <ErrorModal error={error.error} message={error.message} />}

    <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      <Box sx={{ display: "flex", padding: "15px", height: "56px", alignItems: "center" }}>
        <IconButton onClick={() => navigate(`/app`)}>
          <Home />
        </IconButton>
        <Typography variant="h6" noWrap component="div" fontWeight="bold" sx={{ padding: "10px" }}>
          Manchas de Inundação
        </Typography>
        <Toolbar />
      </Box>

      <Divider />

      <Box sx={{ display: "flex", flexDirection: "row", height: "calc(100vh - 56px)" }}>
        <Box sx={{ display: "flex", flexDirection: "column", flex: 7, height: "100%" }}>
          <HidroMap
            recenter
            chooseMap
            expandable
            screenshot
            animateStart={false}
            hidroLayers={layers.current}
          />
        </Box>

        <Divider orientation="vertical" flexItem />

        <Box sx={{ display: "flex", flexDirection: "column", flex: 2, height: "100%", padding: "5px" }}>
          <HidroLayersComponent hidroLayers={layers.current} maxWidth={"100%"} />
        </Box>

      </Box>
    </Box>
  </>;
};

const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));